import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Brand Positioning", desc: "Define the distinct market narrative that separates you from direct competitors." },
  { title: "Messaging Architecture", desc: "Clear voice, category language, and proof points that improve trust instantly." },
  { title: "Identity Direction", desc: "Strategic visual systems that carry authority across digital and physical touchpoints." },
  { title: "Audience Research", desc: "Decision-grade insights into buyer motives, objections, and preference signals." },
  { title: "Go-To-Market Alignment", desc: "Connect brand strategy with sales process, content, and campaign execution." },
  { title: "Brand Governance", desc: "Guidelines and rollout plans that keep teams and agencies aligned over time." },
];

const BrandStrategy = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Brands with"
    titleAccent="strategic gravity."
    subtitle="Brand strategy for ambitious teams that need clarity, coherence, and conversion across every channel."
    features={features}
    ctaLabel="DEFINE MY BRAND"
  />
);

export default BrandStrategy;